<template>
  <a-config-provider :theme="isAdmin ? defaultTheme : userTheme" :locale="componentLocale">
    <router-view v-slot="{ Component }">
      <component :is="Component" :class="{ 'user-theme': !isAdmin }" />
    </router-view>
  </a-config-provider>
</template>

<script setup lang="ts">
import { computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { userTheme } from '@/assets/styles/user-theme'
import { useLocale } from '@/composables/useLocale'
import '@/assets/styles/user-theme.css'

const route = useRoute()
const { locale, t } = useLocale()
const defaultTheme = { inherit: false }
const isAdmin = computed(() => route.path === '/admin' || route.path.startsWith('/admin/'))
const componentLocale = computed(() => !isAdmin.value && locale.value === 'en' ? enUS : zhCN)

watchEffect(() => {
  document.documentElement.lang = !isAdmin.value && locale.value === 'en' ? 'en' : 'zh-CN'
  const fallback = String(route.meta.title || 'TikFlow')
  const title = isAdmin.value ? fallback : t(`route.${String(route.name || '')}`, {}, fallback)
  document.title = title === 'TikFlow' ? title : `${title} - TikFlow`
})
</script>
